module.exports = __webpack_public_path__ + "media/images/metronic/datatable-row-openclose-020aff079148cc5ebb06688d826dc932.png";